import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Trans, i18nMark, withI18n } from 'lingui-react';

import demoTag from '../../assets/images/demo.png';
import logo from '../../assets/images/logo.svg';
import './notFound.css';

class NotFound extends Component {

  componentDidMount() {
    document.title = this.props.i18n._(i18nMark('Security Selfie'));
  }

  navigateTo = () => {
    window.location.href = '/'
  }

  render() {
    return [
      <header key={1} className='app-header'>
        <div className="container-fluid header-container">
          <div className="left-header"
            onClick={
              () => {
                this.navigateTo();
              }
            }>
            <img className="app-demo" alt="" src={demoTag} />
            <img className="app-logo" alt="" src={logo} />
          </div>
        </div>
      </header>,
      <div key={2} className="container notfound-container">
        <div className="row notfound-content">
          <div className="col-12 text-center">
            <h1><Trans id="404 Error" /></h1>
            <h5><Trans id="We are sorry, but the page you are looking for does not exist" /></h5>
            <a onClick={
              () => {
                this.navigateTo();
              }
            } className="homepage-link"><Trans id="Go to Home Page" /></a>
          </div>
        </div>
      </div>
    ];
  }
}

export default withI18n()(withRouter(NotFound));



// WEBPACK FOOTER //
// ./src/screens/NotFound/NotFound.js